<template>

  <svg
    t="1639130631147"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M116.4921875 442.2045038h325.7123163V116.4921875H116.4921875v325.7123163z m46.5303308-279.18198551h232.65165472v232.65165473H163.0225183V163.0225183z m418.7729779-46.53033079v325.7123163h325.7123163V116.4921875h-325.71231632z m279.18198551 279.18198552h-232.65165473V163.0225183h232.65165473v232.65165472zM116.4921875 907.5078125h325.7123163v-325.7123163H116.4921875v325.7123163z m46.5303308-279.18198552h232.65165472v232.65165472H163.0225183v-232.65165472z m418.7729779 279.18198552h325.7123163v-325.7123163h-325.71231632v325.7123163z m46.53033078-279.18198552h232.65165473v232.65165472h-232.65165473v-232.65165472z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconViewGrid',
} as DefineComponent
</script>